import { useEffect, useState } from "react";
import { useSession } from "@clerk/clerk-react";
import { getMyMeetsToday as getMyMeetsTodayApi } from "@/api/meets";
import ActiveMeetingCard from "../cards/active-meets-card";
import { CalendarCheck } from "lucide-react";
import PullToRefresh from 'react-simple-pull-to-refresh';
import PulledDownWrapper from "../wrappers/pulled-down-wrapper";

const TodaysMeetsComp = () => {
const { session } = useSession();
const [records, setRecord] = useState([]);

useEffect(() => {
    getMyMeetsToday()
}, [])

async function getMyMeetsToday(){
    const token = await session.getToken();
    getMyMeetsTodayApi(token).then((_resp) => {
        if(_resp.data.Result === 'OK'){
            setRecord(_resp.data.Records)
        }
    }).catch((_resp) => {
        console.error(_resp)
    }).finally(() => {

    })
}

return (
<>
<PulledDownWrapper onRefresh={getMyMeetsToday}>
    <div className="max-w-[900px] gap-2 grid grid-cols-12">
        <div className="contents">
            {records.length !== 0 && (
                <div className="col-span-12">
                    <div className="text-center py-4 opacity-60">
                        Today
                    </div>
                </div>
            )}
            {records.map((rec, _index) => 
                <div key={rec._id} className={`col-span-12 flex flex-col ${ _index === records.length - 1 ? "mb-40" : " mb-2"}`}>
                    <ActiveMeetingCard _record={rec} _onResp={null}/>
                </div>
            )}
        </div>
        {records.length === 0 && (
            <div className="col-span-12 flex flex-col items-center justify-center py-12 text-center text-zinc-400">
                <CalendarCheck className="w-12 h-12 mb-2 opacity-50"/>
                <h2 className="text-lg font-medium">No Meetings Today</h2>
                <p className="text-sm text-zinc-500">You're all caught up! 🎉</p>
            </div>
        )}
    </div>
</PulledDownWrapper>
</>
);
}

export default TodaysMeetsComp